import { render, staticRenderFns } from "./ArchRegionView.vue?vue&type=template&id=6d3efbe3&scoped=true"
import script from "./ArchRegionView.vue?vue&type=script&lang=js"
export * from "./ArchRegionView.vue?vue&type=script&lang=js"
import style0 from "./ArchRegionView.vue?vue&type=style&index=0&id=6d3efbe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3efbe3",
  null
  
)

export default component.exports